import React from 'react';
import { Card } from "@/components/ui/card";
import { Match } from '../../types/head-to-head';
interface CommonResultsCardProps {
  matches: Match[];
}
interface ResultCount {
  score: string;
  count: number;
  percentage: number;
}
export const CommonResultsCard: React.FC<CommonResultsCardProps> = ({
  matches
}) => {
  const calculateCommonResults = (matches: Match[], isHalfTime: boolean = false): ResultCount[] => {
    const resultCounts = new Map<string, number>();
    matches.forEach(match => {
      const homeScore = isHalfTime ? match.HTHG : match.FTHG;
      const awayScore = isHalfTime ? match.HTAG : match.FTAG;
      const score = `${homeScore}-${awayScore}`;
      resultCounts.set(score, (resultCounts.get(score) || 0) + 1);
    });
    const sortedResults = Array.from(resultCounts.entries()).sort((a, b) => b[1] - a[1]).slice(0, 3).map(([score, count]) => ({
      score,
      count,
      percentage: Math.round(count / matches.length * 100)
    }));
    return sortedResults;
  };
  const fullTimeResults = calculateCommonResults(matches);
  const halfTimeResults = calculateCommonResults(matches, true);
  return <Card className="p-4">
      <h3 className="text-lg font-semibold mb-4">Popular Results</h3>
      <div className="space-y-6">
        <div>
          <h4 className="text-base font-medium mb-3">Full Time Top 3</h4>
          <div className="space-y-2">
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center font-medium">Score</div>
              <div className="text-center font-medium">Count</div>
              <div className="text-center font-medium">%</div>
            </div>
            {fullTimeResults.map((result, index) => <div key={index} className="grid grid-cols-3 gap-4">
                <div className="text-center">{result.score}</div>
                <div className="text-center">{result.count}</div>
                <div className="text-center">{result.percentage}%</div>
              </div>)}
            {fullTimeResults.length === 0 && <div className="text-center text-gray-500">No matches found</div>}
          </div>
        </div>

        <div>
          <h4 className="text-base font-medium mb-3">Half Time Top 3</h4>
          <div className="space-y-2">
            <div className="grid grid-cols-3 gap-4">
              <div className="text-center font-medium">Score</div>
              <div className="text-center font-medium">Count</div>
              <div className="text-center font-medium">%</div>
            </div>
            {halfTimeResults.map((result, index) => <div key={index} className="grid grid-cols-3 gap-4">
                <div className="text-center">{result.score}</div>
                <div className="text-center">{result.count}</div>
                <div className="text-center">{result.percentage}%</div>
              </div>)}
            {halfTimeResults.length === 0 && <div className="text-center text-gray-500">No matches found</div>}
          </div>
        </div>
      </div>
    </Card>;
};